import { module } from "angular";
import { SiteMenuItemsService } from "./SiteMenuItemsService";

module("mmManagePortal").service("irSiteMenuItemsService", SiteMenuItemsService);
